<template>
  <div class="calc_ads">
    <a href="https://hardbg.ru?refcode=VMMM" target="_blank">
      <img :src="ads1" class="grey lighten-2" v-if="show" />
      <img :src="ads2" class="grey lighten-2" v-if="!show" />
    </a>
  </div>
</template>
<script>
import ads1 from "@/assets/ads1.webp";
import ads2 from "@/assets/ads2.webp";
export default {
  name: "CalcAds",
  components: {},
  data: () => ({
    ads1,
    ads2,
    show: false,
  }),
  methods: {
    toggel() {
      localStorage.setItem("ads", !this.show);
      this.show = !this.show;
    },
  },
  mounted() {
    // if need to load new ads on every mount
    // const show = localStorage.getItem('ads')
    // this.show = show === 'false' ? false : true
    // this.toggel()

    // if need to load new ads every 8000 millisecond
    setInterval(this.toggel, 8000);
  },
};
</script>
<style lang="sass" scoped>
.calc_ads
  position: relative
  height: fit-content
  display: flex
  justify-content: center
  max-width: 800px
  img
    margin: 0 auto
    width: 100%
    transition: all .5s linear
</style>
